<div class="text-white py-16">
  @if (loaded()) {

  @if (notFound()) {
  <app-not-found-page></app-not-found-page>
  } @else {
  @if (page(); as page) {
  <div class="max-w-screen-2xl mx-auto px-8">
    <nav class="flex flex-row gap-2">
      <a [routerLink]="['/', section()]" class="font-bold text-primary underline">
        {{ section() === 'blog' ? 'Blog' : 'News' }}
      </a>
      <span class="select-none text-primary font-bold">&gt;</span>
      <p class="font-bold text-white">{{ page.title }}</p>
    </nav>

    <h1 class="text-4xl md:text-6xl font-bold pb-2 pt-4 leading-tight">{{ page.title }}</h1>

    @if (page.published_at) {
    <p class="text-gray-400 pb-8">{{ page.published_at | date:'d MMMM yyyy' }}</p>
    } @else {
    <div class="pb-8"></div>
    }
  </div>

  <div class="flex flex-col gap-8">
    @for (item of page.content; track $index) {
    <ng-container appContentBlock [data]="item.data" [type]="item.type"></ng-container>
    }
  </div>
  }
  }
  } @else {
  <div class="flex flex-row items-center justify-center">
    <app-spinner></app-spinner>
  </div>
  }
</div>
